import { DataModel } from "common/models/utility-models/base-model";

export class BatchesModel extends DataModel {
    batch_number: any = '';
    duration_start: any = '';
    duration_end: any = '';

}

export class BatchListModel extends DataModel {

    batch_number: any = " ";
    duration_start: any = "";
    duration_end: any = "";
    wantToDelete: any = 0;
}